import React from 'react';
import { AlertNotice, HorizontalScroll } from 'shared/components';
import { useTranslation } from 'react-i18next';
import './TestMaterials.scss';
import PropTypes from 'prop-types';

const TestMaterials = ({ materials }) => {
  const { t } = useTranslation();
  return (
    <div className="test-materials-container">
      <h3>{t('reviewAndCloseRoom.examineeStatus.materials')}</h3>
      <AlertNotice
        message={t('reviewAndCloseRoom.examineeStatus.bookletCount')}
        type="information"
      />
      <div className="materials-card-container">
        <HorizontalScroll>
          {materials.map((material, i) => (
            <div key={`material-${i}`} className="materials-card">
              <h6 className="text-ellipsis">{material.name}</h6>
              <div className="materials-card-item">
                <div>{t('reviewAndCloseRoom.examineeStatus.used')}</div>
                <div>{material.usedCount ?? 0}</div>
              </div>
              <div className="materials-card-item">
                <div>{t('reviewAndCloseRoom.examineeStatus.unused')}</div>
                <div>{material.unusedCount ?? 0}</div>
              </div>
              <div className="materials-card-item total">
                <div>{t('reviewAndCloseRoom.examineeStatus.total')}</div>
                <div>{material.count}</div>
              </div>
            </div>
          ))}
        </HorizontalScroll>
      </div>
      <h3>{t('reviewAndCloseRoom.examineeStatus.answer')}</h3>
    </div>
  );
};

export default TestMaterials;

TestMaterials.propTypes = {
  materials: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
